var elevations = {
  100: 4,
  200: 8,
  300: 12,
  400: 24,
  500: 36
};
function isElevationThemeKeys(key) {
  return Object.keys(elevations).includes("".concat(key));
}
function assertIsElevationThemeKeys(key) {
  var shouldThrow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!isElevationThemeKeys(key) && shouldThrow) {
    throw new Error('Not a DemographicDataVariableKey!');
  }
  return;
}

export { assertIsElevationThemeKeys, elevations, isElevationThemeKeys };
//# sourceMappingURL=elevations.esm.js.map
